export const refsHeader = {
  burgerBtn: document.querySelector('.open-burger-btn'),

  burgerMenu: document.querySelector('.burger-menu'),

  closeBurgerBtn: document.querySelector('.close-burger-icon'),

  burgerLogoLinkMain: document.querySelector('.logo-link-burger'),

  burgerLinkSection: document.querySelectorAll('.burger-nav-link'),

  burgerOrderBtn: document.querySelector('.burger-order-btn'),
};
